import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import errorToast from "../helper-components/error-toast";
import {
  departmentListAction,
  RolesListAction,
} from "../../redux/actions/general-action";
import LoadingSpinner from "../helper-components/loading-spinner";
import { Field, Form, Formik } from "formik";

import AddButton from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import {
  departmentCreateAction,
  departmentDeleteAction,
  departmentEditAction,
  departmentSearchListAction,
} from "../../redux/actions/settings-action";
import successToast from "../helper-components/success-toast";

function DepartmentTable({
  pageLoading,
  setPageLoading,
  searchValue,
  reload,
  setReload,
}) {
  const [initialData, setItemTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  const tableHeading = [
    "Department Code",
    "Department Role",
    "Description",
    "Action",
  ];
  const initialValues = {
    data: initialData,
    newLine: {
      department_code: "",
      department_name: "",
      description: "",
    },
  };
  const dispatch = useDispatch();

  const onSuccess = (data) => {
    setItemTypeData(data?.data?.rows);
    setLoading(false);
    console.log("Roles loaded successfully", data.data);
  };

  const onSaveSuccess = (data) => {
    fetchData();
    setLoading(false);
    successToast(data?.message);
  };

  const onSaveError = (data) => {
    fetchData();
    setLoading(false);
    errorToast(data?.message);
  };

  const onError = (data) => {
    setLoading(false);
    errorToast(data?.message);
  };

  const fetchData = (searchValue = "") => {
    if (loading) {
      return;
    }

    setLoading(true);
    dispatch(departmentSearchListAction(searchValue, onSuccess, onError));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (reload) {
      fetchData();
      setReload(false);
    }
  }, [reload]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 800);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedSearchValue !== "" || searchValue === "") {
      fetchData(debouncedSearchValue);
    }
  }, [debouncedSearchValue]);

  const onSubmit = (values) => {
    if (!loading) {
      const changedObjects = [];
      let newLineObject = null;

      initialData.forEach((item, index) => {
        if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
          changedObjects.push(values.data[index]);
        } else return;
      });

      if (
        JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
      ) {
        if (
          values.newLine.department_code === "" ||
          values.newLine.department_name === ""
        ) {
          errorToast("Department Code and	Department Role are required");
        } else newLineObject = values.newLine;
      }

      if (newLineObject !== null) {
        setLoading(true);
        dispatch(
          departmentCreateAction(newLineObject, onSaveSuccess, onSaveError)
        );
      }

      if (changedObjects.length > 0) {
        setLoading(true);
        dispatch(
          departmentEditAction(changedObjects, onSaveSuccess, onSaveError)
        );
      }
    }
  };

  const onClickDelete = (roleId) => {
    if (!loading) {
      setLoading(true);
      dispatch(
        departmentDeleteAction(
          { department_id: roleId },
          onSaveSuccess,
          onSaveError
        )
      );
    }
  };
  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <Form className="pt-1">
          <div
            className="flex flex-col justify-between rounded-xl"
            style={{ height: "74vh" }}
          >
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {values?.data?.map((item, index) => (
                      <tr
                        className={` bg-[var(--list-table-row-bg)]
                                     h-[50px] `}
                        key={index}
                      >
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <Field
                            maxLength={10}
                            onChange={(e) => {
                              const value = e.target.value.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );
                              handleFieldChange(
                                `data[${index}]`,
                                "department_code",
                                value,
                                setFieldValue
                              );
                            }}
                            name={`data[${index}].department_code`}
                            placeholder="Enter Code"
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <Field
                            maxLength={20}
                            onChange={(e) => {
                              let value = e.target.value;

                              // 1. Remove special characters (only letters, numbers, spaces allowed)
                              value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                              // 2. Prevent leading space
                              value = value.replace(/^\s+/, "");

                              // 3. Prevent consecutive spaces
                              value = value.replace(/\s+/g, " ");
                              handleFieldChange(
                                `data[${index}]`,
                                "department_name",
                                value,
                                setFieldValue
                              );
                            }}
                            name={`data[${index}].department_name`}
                            placeholder="Enter Name"
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-7/12">
                          <Field
                            maxLength={80}
                            onChange={(e) => {
                              let value = e.target.value;

                              // 1. Remove special characters (only letters, numbers, spaces allowed)
                              value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                              // 2. Prevent leading space
                              value = value.replace(/^\s+/, "");

                              // 3. Prevent consecutive spaces
                              value = value.replace(/\s+/g, " ");

                              handleFieldChange(
                                `data[${index}]`,
                                "description",
                                value,
                                setFieldValue
                              );
                            }}
                            name={`data[${index}].description`}
                            placeholder="Enter Description"
                            className="w-full border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          />
                        </td>
                        <td className="tab-cell align-middle text-sm fw_400 text-secondary w-1/12 ">
                          <div className="flex items-center">
                            <button
                              type="button"
                              onClick={() => onClickDelete(item?.department_id)}
                            >
                              <DeleteIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                        <Field
                          maxLength={10}
                          onChange={(e) => {
                            const value = e.target.value.replace(
                              /[^a-zA-Z0-9]/g,
                              ""
                            );
                            handleFieldChange(
                              `newLine`,
                              "department_code",
                              value,
                              setFieldValue
                            );
                          }}
                          name="newLine.department_code"
                          placeholder="Enter Code"
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                        <Field
                          maxLength={20}
                          onChange={(e) => {
                            let value = e.target.value;

                            // 1. Remove special characters (only letters, numbers, spaces allowed)
                            value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                            // 2. Prevent leading space
                            value = value.replace(/^\s+/, "");

                            // 3. Prevent consecutive spaces
                            value = value.replace(/\s+/g, " ");
                            handleFieldChange(
                              `newLine`,
                              "department_name",
                              value,
                              setFieldValue
                            );
                          }}
                          name="newLine.department_name"
                          placeholder="Enter Name"
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-7/12">
                        <Field
                          maxLength={80}
                          onChange={(e) => {
                            let value = e.target.value;

                            // 1. Remove special characters (only letters, numbers, spaces allowed)
                            value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                            // 2. Prevent leading space
                            value = value.replace(/^\s+/, "");

                            // 3. Prevent consecutive spaces
                            value = value.replace(/\s+/g, " ");

                            handleFieldChange(
                              `newLine`,
                              "description",
                              value,
                              setFieldValue
                            );
                          }}
                          name="newLine.description"
                          placeholder="Enter Description"
                          className="w-full border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-1/12"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default DepartmentTable;
